import * as React from 'react';

import { Checkbox } from '../forms';

interface IProps {
  value?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isReadOnly?: boolean;
  hint?: string;
  className?: string;
  label: string;
  dataAction?: string;
}

const DisableEmailNotifications: React.FC<IProps> = ({
  value,
  onChange,
  isReadOnly,
  hint,
  className,
  label,
  dataAction,
}) => {
  return (
    <Checkbox
      checked={value}
      onChange={onChange}
      text={label}
      hint={hint}
      className={className}
      isReadOnly={isReadOnly}
      id={hint}
      dataAction={dataAction}
    />
  );
};

export default DisableEmailNotifications;
